import { useGet } from "../../common/hooks";
import { Goalie } from "../../common/interfaces";
import {GoalieDivisionTable} from "../components/GoalieDivisionTable"


export function GoaliePlacement () {
    const allGoalies = useGet<Goalie[]>("/api/goalies?active=true");

    if (!allGoalies.data) {
        return <div>Loading...</div>;
    }

    return (
        <GoalieDivisionTable
            goalies={allGoalies.data}/>
    )
}